import { useMutation } from '@apollo/client'
import {
  Button,
  FormPasswordInput,
} from 'components/atoms'
import Form from 'components/atoms/Form'
import { logError } from 'logService'
import { useState } from 'react'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import { colors } from 'theme'

import { UPDATE_MY_PASSWORD } from '@/graphql/mutations/user'

const ChangePassword = () => {
  const [updateMyPassword] = useMutation(UPDATE_MY_PASSWORD)
  const [form, setForm] = useState({
    oldPassword: '',
    newPassword: '',
    newPassword2: '',
  })

  const [errors, setErrors] = useState({})

  const handleChange = (value, name) => {
    let updatedErrors = { ...errors }

    updateFormValue(value, name)

    setErrors({
      ...updatedErrors,
      [name]: null,
    })
  }

  const updateFormValue = (value, name) => {
    setForm({
      ...form,
      [name]: value,
    })
  }

  const handleSubmit = async e => {
    e.preventDefault()

    const {
      oldPassword,
      newPassword,
      newPassword2,
    } = form
    const updatedErrors = {}

    if (oldPassword.length === 0) {
      updatedErrors.oldPassword = 'Champ obligatoire'
    }
    if (newPassword.length === 0) {
      updatedErrors.newPassword = 'Champ obligatoire'
    }
    if (newPassword2.length === 0) {
      updatedErrors.newPassword2 = 'Champ obligatoire'
    }
    if (newPassword !== newPassword2) {
      updatedErrors.newPassword2 = 'Le nouveau mot de passe ne correspond pas'
    }

    const hasError = Object.values(updatedErrors).some(error => typeof error === 'string')

    if (!hasError) {
      try {
        const { data } = await updateMyPassword({
          variables: {
            oldPassword,
            newPassword,
          },
        })
        if (!data.updateMyPassword) {
          updatedErrors.oldPassword = 'Mauvais mot de passe'
          setErrors(updatedErrors)

          return
        }

        toast.success('Votre mot de passe a été changé', {
          position: 'top-center',
        })
      } catch (error) {
        toast.error('Oups! une erreur est survenue', {
          position: 'top-center',
        })
        logError('GRAPHQL', 'register', error)
      }
    }
    setErrors(errors)
  }

  const {
    oldPassword,
    newPassword,
    newPassword2,
  } = form

  return (
    <Form onSubmit={ handleSubmit }>
      <FormPasswordInput
        error={ errors.oldPassword }
        isRequired
        label="Mot de passe actuel"
        name="oldPassword"
        value={ oldPassword }
        onChangeText={ handleChange }
      />
      <FormPasswordInput
        error={ errors.newPassword }
        isRequired
        label="Nouveau mot de passe"
        name="newPassword"
        value={ newPassword }
        onChangeText={ handleChange }
      />
      <FormPasswordInput
        error={ errors.newPassword2 }
        isRequired
        label="Confirmer le nouveau mot de passe"
        name="newPassword2"
        value={ newPassword2 }
        onChangeText={ handleChange }
      />
      <Edit
        type="submit"
        variant="secondary"
      >
        Modifier
      </Edit>
    </Form>
  )
}

const Edit = styled(Button)`
  && {
    align-self: flex-end;
    margin-top: 1.3rem;
    font-family: Montserrat;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: bold;
    color: ${colors.lightGreen};
  }
`

export default ChangePassword
